var React = require('react');

function ArcHeight (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M2 19c7-5 14-5 22 0","fill":"none","stroke":"#2F73A7","strokeWidth":"2.5","strokeLinecap":"round","key":0}),React.createElement("text",{"fill":"#0D3B5E","fontFamily":"Arial","fontSize":"25","x":"7","y":"22","key":1},"↕")]);
}

ArcHeight.defaultProps = {"width":"26","height":"29"};

module.exports = ArcHeight;

ArcHeight.default = ArcHeight;
